import { createSlice } from "@reduxjs/toolkit";
import { InitialCartoonStockFormData } from "../../ConstantData/InitialData";
import { InitialCartoonStockDuplicateFormData } from "../../ConstantData/InitialDuplicateData";
const cartoonStockSlice = createSlice({
  name: "cartoonstock",
  initialState: {
    cartoonStockList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    billList: [],
    // billDataList: {},
    initialData: InitialCartoonStockFormData,
    initialDuplicateData: InitialCartoonStockDuplicateFormData,
  },
  reducers: {
    getAllCartoonStocks: (state, action) => {
      state.cartoonStockList = action.payload;
    },
    getCartoonStockDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialCartoonStockFormData };
    },
    setDuplicateInitialData: (state) => {
      state.initialDuplicateData = { ...InitialCartoonStockDuplicateFormData };
    },
    getBillList: (state, action) => {
      if (action.payload.data.length <= 0) {
        state.initialDuplicateData = [];
      }
      state.billList = action.payload.data;
    },
    getDataUsingBill: (state, action) => {
      state.initialDuplicateData = action.payload.data;
      state.dataEdit = action.payload.editData;
    },
    adjustCartoonStockItem: (state, action) => {},
    deleteCartoonStock: () => {},
  },
});

export const cartoonStockSliceAction = cartoonStockSlice.actions;
export default cartoonStockSlice.reducer;
